
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Card from 'vux/src/components/card/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Search from 'vux/src/components/search/index.vue'

import {listDevice, moduleList} from '@/api/device';
import {getInfo} from '@/api/login';
import InfiniteLoading from 'vue-infinite-loading';
import store from '@/store'
import logoImg from '@/assets/logo2.png'
import {treeselect} from "@/api/system/dept";

export default {
name: 'device-module',
components: {
Grid,
XButton,
GridItem,
CellBox,
Flexbox,
Card,
FlexboxItem,
Toast,
Icon,
Search,
InfiniteLoading
},
data() {
return {
deviceList: [],
userInfo: {},
logo: '',
searchValue: '',
queryParams: {
pageNum: 0,
pageSize: 10,
lastDataTime: "x"
}
}
},
created() {
this.queryParams.deptId = this.$route.params.id;
this.getUser();

},
methods: {
reLogin() {
this.$cookies.set('reLogin',1);
this.$router.push('/');
},
devStatusCheck(time) {
let status = '离线'
if (time) {

let currentDate = new Date();

let specifiedDate = new Date(time);


let timeDifferenceInMinutes = (currentDate - specifiedDate) / 1000 / 60;


if (timeDifferenceInMinutes < 30) {
status = '在线'
}
}
return status;
},
async getUser() {
getInfo().then(res => {
this.userInfo = res.user
let logo = this.userInfo.dept ? (this.userInfo.dept.logoH5 ? process.env.VUE_APP_BASE_API + this.userInfo.dept.logoH5 : '') : '';
store.commit('SET_LOGO', logo)
store.commit('SET_ROLES', res.roles)
store.commit('SET_PERMISSIONS', res.permissions)
if (logo) {
this.logo = logo;
} else {
this.logo = logoImg;
}

}).catch(error => {
this.$vux.toast.show({
type: 'warn',
text: error
})
})
},
getDevs() {
moduleList(this.queryParams).then(res => {
this.deviceList = res.rows || []
this.total = res.total
})
},
async onInfinite() {
++this.queryParams.pageNum
moduleList(this.queryParams).then(response => {
if (response.rows.length) {
response.rows.forEach(device => {
device.newDeviceDataDtos = []
for (let i = 0; i < device.deviceDataDtos.length; i += 2) {
device.newDeviceDataDtos.push([device.deviceDataDtos[i], device.deviceDataDtos[i + 1]]);
}
})
this.deviceList = this.deviceList.concat(response.rows);
this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');
if (this.deviceList.length >= response.total) {
this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
}
} else {
this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
}
});
}
}
}



// WEBPACK FOOTER //
// ./src/components/module.vue